import { render } from "./PurchasesTab.vue?vue&type=template&id=350b0678"
import script from "./PurchasesTab.vue?vue&type=script&lang=js"
export * from "./PurchasesTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__